let messagesDE

export default messagesDE = {

}